module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAIAAADgcHrrAAAAK3RFWHRDcmVhdGlvbiBUaW1lAHdvIDI4IGRlYyAyMDA1IDEyOjM2OjAxICswMTAwgi8KzwAAAAd0SU1FB9UMHAsuH9tCySIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAEZ0FNQQAAsY8L/GEFAAAAkUlEQVR42mP8z4AK+BkYWBgY3jLgB0xQWpmBQQvMAJJWDAyM+PT8h+D/7gz/TzD8P8vw3xHMFWf4XwJm4ECvgMZCHXmZgYGdgUENZqAYWBIbeAuWYYK6NJiBwQvsKyBQYWBwJeA3RvQgsWdg4GFg2IpTw1sURxINkBxJOqCXtjdgxILsaCL1QLX9h3GI1AYMEgCm3y/4WkXIPAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/template/zh-hans.png
// module id = 675
// module chunks = 0